var _style, _g, _defs, _polygon, _defs2, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegurosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-home",
    className: "logo-home-class",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 317 98",
    style: {
      enableBackground: "new 0 0 317 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n#logo-home .st0_0{\n    fill:#D9272E !important;\n}\n\n#logo-home .st1_0{\n    clip-path:url(#SVGID_2_logo)!important;fill: #D9272E!important;\n}\n\n#logo-home .st2_0{\n    clip-path:url(#SVGID_5_logo)!important;fill: #D9272E!important;\n}\n\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M108.7,85.6l9.7-28.4c1.3-3.8,3.2-5.4,6-5.4c2.7,0,4.7,1.7,5.9,5.4l9.6,28.4h-8.3l-2.3-7.6h-10.4l-2.2,7.6 H108.7z M127.6,71.9l-3.5-11.8l-3.4,11.8H127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M167.1,51.9v25.8c0,1.7,0.7,2.7,2.6,2.7c0.8,0,1.4-0.1,2.2-0.3l0.7,5.4c-1.5,0.3-3.4,0.5-4.9,0.5 c-5.6,0-7.9-2.5-7.9-7.4V51.9H167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M174.5,77.6c0-4.6,2-7.4,7.3-8.3c2.5-0.4,4.8-0.5,7.3-0.6c0-2.3-1.2-3.2-3.9-3.2c-3.1,0-6.6,0.4-9.2,0.7 l-0.6-5.5c2.6-0.5,6.4-1,10.2-1c5.8,0,10.6,1.6,10.6,8.4v10.3c0,1.8-0.1,3.3-0.2,5c-3.1,1.8-7,2.5-11.4,2.5 C177.3,85.9,174.5,83.2,174.5,77.6 M189,73.5c-1.6,0.1-3.3,0.2-4.8,0.5c-1.8,0.4-2.6,1.1-2.6,3.4c0,2.2,1.3,2.8,3.5,2.8 c1.2,0,2.5-0.1,3.6-0.5c0.1-1,0.2-2.3,0.2-3.4V73.5z M188.4,56.9h-5.6l3.8-6.4h7.3L188.4,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M209.1,85.6h-7.3V67.2c0-1.8,0.1-3.3,0.2-5c3.1-1.8,7.1-2.5,11.3-2.5c9.4,0,10.5,4,10.5,9.8v16.1h-7.3V70 c0-3.1-0.6-4.4-4.1-4.4c-1.1,0-2.4,0.2-3.2,0.5c-0.1,1-0.2,2.3-0.2,3.4V85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M246.5,53.9c0-2.6,1-3.7,3.9-3.7c3,0,4,1,4,3.7c0,2.6-1,3.7-4,3.7C247.4,57.6,246.5,56.5,246.5,53.9 M246.7,59.7h7.4v25.9h-7.4V59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M274.8,51.9h7.4v26.5c0,1.8-0.1,3.3-0.2,5c-2.9,1.8-7,2.5-10.5,2.5c-8.7,0-12.3-3.1-12.3-13.1 c0-10,3.6-13.1,11.6-13.1c1.3,0,2.8,0.1,4.1,0.4V51.9z M272,65.6c-5.3,0-5.5,3.1-5.5,7.2c0,3.6,0.2,7.3,4.9,7.3 c1.2,0,2.4-0.2,3.2-0.5c0.1-1,0.2-2.3,0.2-3.4V65.9C274,65.7,272.9,65.6,272,65.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M286.8,77.6c0-4.6,2-7.4,7.3-8.3c2.5-0.4,4.8-0.5,7.3-0.6c0-2.3-1.2-3.2-3.9-3.2c-3.1,0-6.6,0.4-9.2,0.7 l-0.6-5.5c2.6-0.5,6.4-1,10.2-1c5.8,0,10.6,1.6,10.6,8.4v10.3c0,1.8-0.1,3.3-0.2,5c-3.1,1.8-7,2.5-11.4,2.5 C289.7,85.9,286.8,83.2,286.8,77.6 M301.3,73.5c-1.6,0.1-3.3,0.2-4.8,0.5c-1.8,0.4-2.6,1.1-2.6,3.4c0,2.2,1.3,2.8,3.6,2.8 c1.2,0,2.5-0.1,3.6-0.5c0.1-1,0.2-2.3,0.2-3.4V73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M236.3,51.9v7.8h6.3v6.1h-6.3v11.9c0,1.7,0.7,2.7,2.6,2.7c0.8,0,1.5,0,2.4-0.1l0.6,5.2 c-1.5,0.3-3.4,0.5-4.9,0.5c-5.6,0-8-2.5-8-7.4V51.9H236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M149.5,51.9v7.8h6.3v6.1h-6.3v11.9c0,1.7,0.7,2.7,2.6,2.7c0.8,0,1.5,0,2.4-0.1l0.6,5.2 c-1.5,0.3-3.4,0.5-4.9,0.5c-5.6,0-8-2.5-8-7.4V51.9H149.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_logo",
    d: "M10.9,12.1c-1.3,0-2.4,1.1-2.4,2.4v39.7c0,19.2,12.4,31.7,31.6,31.7h16.4c1.3,0,2.4-1.1,2.4-2.4V64 c0-1.3-1.1-2.4-2.4-2.4H46c-1.3,0-7.6-0.2-7.6-7.6V14.5c0-1.3-1.1-2.4-2.4-2.4H10.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_logo"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_logo",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_logo",
    gradientUnits: "userSpaceOnUse",
    x1: -61.2576,
    y1: 403.9803,
    x2: -60.1986,
    y2: 403.9803,
    gradientTransform: "matrix(28.2446 5.38 5.38 -28.2446 -408.5729 11789.001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B90026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7935,
    style: {
      stopColor: "#A30E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9509,
    style: {
      stopColor: "#9E1126"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E1126"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1_0",
    points: "10.3,2.8 72.4,14.7 57.1,95.2 -5.1,83.3 \t\t"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_logo",
    d: "M44.4,22.7c-1.3,0-2.4,1.1-2.4,2.4v22.4c0,1.3,1.1,2.4,2.4,2.4h11.9c1.3,0,6,0.2,6,7.6v25.9 c0,1.3,1.1,2.4,2.4,2.4h25c1.3,0,2.4-1.1,2.4-2.4v-29c0-19.2-12.4-31.8-31.6-31.8H44.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_logo"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_logo",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_logo",
    gradientUnits: "userSpaceOnUse",
    x1: -56.1729,
    y1: 402.8435,
    x2: -55.1139,
    y2: 402.8435,
    gradientTransform: "matrix(-47.4286 -20.5823 -20.5823 47.4286 5717.8198 -20197.9531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9272E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3809,
    style: {
      stopColor: "#B30326"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    style: {
      stopColor: "#A40D26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E1126"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2_0",
    points: "84.3,104.3 18.9,75.9 50,4.4 115.4,32.7 \t\t"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M118.2,21.6c0,2.7,1.9,3.1,5.4,4.1c6.6,1.8,9,4.4,9,10.3c0,7.4-4.5,10.1-12.4,10.1c-3.8,0-7.1-0.5-9.8-1.1 l0.7-6c2.3,0.4,6.2,0.8,8.7,0.8c3.2,0,4.8-0.8,4.8-3.4c0-2.4-1.8-3.1-4.8-4.1c-5.9-1.8-9.4-3.8-9.4-10c0-7.3,4.3-9.6,11.9-9.6 c3.7,0,7.4,0.6,9.7,1.1l-0.7,5.9c-2.2-0.4-4.9-0.8-7.5-0.8C121.6,18.7,118.2,18.8,118.2,21.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M136,33.1c0-9.1,2.9-12.9,11.3-12.9c9.3,0,11.1,4.9,11.1,12.6c0,0.7,0,1.4-0.1,2.2c-2.8,0.5-8,1.1-11.4,1.3 l-3.8,0.2c0.2,3,1.8,3.7,5.1,3.7c3.4,0,6.5-0.4,9.1-0.7L158,45c-2.6,0.4-6.2,1-11.1,1C138.3,46,136,40.5,136,33.1 M146.5,31.3 c1.4-0.1,3.5-0.3,4.7-0.4c0-0.2,0-0.6,0-0.8c0-2.8-1-4.2-3.9-4.2c-3.9,0-4.4,2.4-4.4,5.6L146.5,31.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M189.2,20.6h7.2v15.3c0,3,0.6,4.3,4,4.3c1.1,0,2.3-0.2,3.1-0.5c0.1-1,0.2-2.2,0.2-3.4V20.6h7.2v18 c0,1.8-0.1,3.2-0.2,4.9c-3,1.7-7,2.5-11.1,2.5c-9.2,0-10.3-3.9-10.3-9.6V20.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M215.7,45.6v-18c0-1.8,0.1-3.2,0.2-4.9c2.8-1.7,6.8-2.5,10.3-2.5c1,0,1.9,0,2.8,0.2l-0.6,5.8 c-0.5-0.1-1.2-0.1-1.7-0.1c-1.3,0-2.8,0.3-3.7,0.7c-0.1,1-0.1,2.2-0.1,3.4v15.5H215.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M231,33.1c0-9.3,3-12.9,11.3-12.9c8.3,0,11.3,3.6,11.3,12.9c0,9.3-3,12.9-11.3,12.9C234,46,231,42.4,231,33.1 M246.4,33.1c0-5.5-0.8-7-4.1-7c-3.3,0-4.1,1.4-4.1,7c0,5.6,0.8,7,4.1,7C245.6,40.1,246.4,38.6,246.4,33.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M264,27.5c0,1.7,2.1,2,4.1,2.7c4.1,1.4,7.6,2.3,7.6,8c0,6.1-4.4,7.8-10,7.8c-3.1,0-6.7-0.4-9.2-1.2l0.7-5.3 c1.8,0.4,5.1,0.8,7,0.8c1.8,0,4.3,0.1,4.3-1.9c0-1.9-1.9-2.1-3.7-2.6c-3.8-1.2-7.9-2.6-7.9-8c0-5.8,4.1-7.5,9.1-7.5 c3.7,0,6.2,0.3,9.5,1.1l-0.7,5.2c-2-0.4-4.2-0.8-6.5-0.8C266.4,25.8,264,25.8,264,27.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0_0",
    d: "M185,22.2c-3-1.8-7.1-2.6-10.8-2.6c-8.6,0-12.6,3.1-12.6,13.2c0,10,3.8,13.1,11.8,13.1c1.3,0,2.9-0.1,4.2-0.4 v0.4c0,2.8-1.5,4.2-4.5,4.2c-0.4,0-2.4,0-2.6,0v6c0.5,0,2.8,0,3.6,0c6,0,11-1.7,11-8.7V27.3C185.3,25.5,185.2,24,185,22.2 M177.7,39.5c-0.9,0.2-2,0.4-2.9,0.4c-5.4,0-5.7-3.1-5.7-7.1c0-3.5,0.4-7.2,5.1-7.2c1.2,0,2.5,0.2,3.3,0.5c0.1,1.1,0.2,2.3,0.2,3.5 V39.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegurosLogo);
export default __webpack_public_path__ + "static/media/seguros-logo.bd2c0071f5d6fd5e00462aa81de13675.svg";
export { ForwardRef as ReactComponent };